import { ReplaySubject } from 'rxjs'

export default class TabState {
    constructor(teleport, activeTabClass) {
        this.active = new ReplaySubject(1)
        this.activeTabClass = activeTabClass
        this.teleport = teleport
        this.tabs = {}
    }
}
